import { LocalActivity } from "@mui/icons-material";
import * as Yup from "yup";

const NEXO = "NEXO";
const OPI = "OPI";
const LOCAL = "LOCAL";

const noSpecialCharRegex = /^[A-Za-z0-9\- ]*$/;
const alphaNumericRegex = /^[A-Fa-f0-9]*$/;


// Interface: Yup.string().required("Interface is required"),
// If Interface is NEXO, then you should write into POSDesc, POIID, POSSoftware. All 3 are mandatory fields. You can also write to PrintOnTerminal and PrintOnPOS.
// If Interface is OPI, then you should write into POSDesc, TID, SiteId and WSNo. All 4 fields are mandatory
const schema = Yup.object({
  attributes: Yup.object({
    POSDesc: Yup.string()
      .matches(noSpecialCharRegex, "No special characters allowed")
      .max(36, "POS description should be less than 36 characters")
      .required("POS description is required"),
    POIID: Yup.array().when("Interface", {
      is: (val) => val === NEXO,
      then: () => Yup.array().of(
          Yup.string().required("POS Device ID is required")
      ).min(1),
    }),
    POSSoftware: Yup.string().when("Interface", {
      is: (val) => val === NEXO,
      then: () => Yup.string().required("POS Software is required"),
    }),
    TID: Yup.string().when("Interface", {
      is: (val) => val === OPI,
      then: () => Yup.string().required("POS Device ID is required"),
    }),
    SiteId: Yup.string().when("Interface", {
      is: (val) => val === OPI,
      then: () => Yup.string().required("Site Id is required"),
    }),
    WSNo: Yup.string().when("Interface", {
      is: (val) => val === OPI,
      then: () => Yup.string().required("Workstation Number is required"),
    }),
    KEK: Yup.string().when("AuthenticationType", {
      is: (val) => val ==="local",
      then: () => Yup.string()
      .test('len', 'Must be exactly 48 characters', value => value?.length === 48)
      .matches(alphaNumericRegex, "Must be an hexa code (a-fA-F0-9)")
    }),
    KEKIdentifier: Yup.string().when("AuthenticationType", {
      is: (val) => val ==="local",
      then: () => Yup.string()
      .test('len', 'Must be entered', value => value?.length > 0)
    }),
    KEKVersion: Yup.string().when("AuthenticationType", {
      is: (val) => val ==="local",
      then: () => Yup.string()
      .test('len', 'Must be entered', value => value?.length > 0)
    }),
  }),
});

export default schema;
